<template>
  <div class="service-policy-page">
    <!-- Start cyber Main Menu Area -->
    <div
      id="sticky-header"
      class="cyber_nav_manu d-md-none d-lg-block d-sm-none d-none"
    >
      <div class="container">
        <div class="row align-items-center">
          <div class="navbar-content">
            <div class="logo">
              <a class="logo_img" href="/" title="ipipbright">
                <img :src="require('../assets/images/ipipbright.png')" style="height: 73px;" alt="" />
              </a>
            </div>
            <nav class="cyber_menu">
              <ul class="nav_scroll">
                <li><router-link to="/" class="nav-link">{{ t.home }}</router-link></li>
                <li>
                  <router-link to="/" class="nav-link active">{{ t.services }}</router-link>
                  <ul class="sub-menu">
                    <li><router-link to="/dynamic">{{ t.serviceDynamic }}</router-link></li>
                  </ul>
                </li>
                <li><router-link to="/faq" class="nav-link">{{ t.tutorial }}</router-link>
                  <ul class="sub-menu">
                    <li><router-link to="/faq">{{ t.faq }}</router-link></li>
                  </ul>
                </li>
                <li>
                  <a href="javascript:void(0);" >{{ languageState.currentLanguage === 'en' ? 'English' : '简体中文' }}</a>
                  <ul class="sub-menu">
                    <li><a href="javascript:void(0);" @click="setLanguage('en')">English</a></li>
                    <li><a href="javascript:void(0);" @click="setLanguage('zh')">简体中文</a></li>
                  </ul>
                </li>
              </ul>
              <div class="auth-buttons">
                <router-link to="/login" class="auth-btn login-btn">{{ t.login }}</router-link>
                <router-link to="/register" class="auth-btn register-btn">{{ t.register }}</router-link>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile-menu-area d-sm-block d-md-block d-lg-none">
      <div class="mobile-menu-container">
        <div class="mobile-menu-header">
          <div class="mobile-menu-logo">
            <a href="/" title="ipipbright">
              <img :src="require('../assets/images/ipipbright.png')" style="height: 40px; margin: 10px 0 0 15px;" alt="ipipbright" />
            </a>
          </div>
          <!-- <a href="javascript:void(0);" class="mobile-menu-toggle" @click="toggleMobileMenu">
            <span></span>
            <span></span>
            <span></span>
          </a> -->
        </div>
        <div class="mobile-menu-body" v-show="isMobileMenuOpen">
          <ul class="mobile-menu-list">
            <li class="mobile-menu-item"><a href="javascript:void(0);" class="mobile-menu-link" @click="handleMobileNavClick('/')">{{ t.home }}</a></li>
            <li class="mobile-menu-item">
              <div class="mobile-menu-link-wrapper">
                <a href="#home" class="mobile-menu-link has-submenu" @click.stop="toggleDropdown($event, 'Package')">{{ t.services }}</a>
                <a href="javascript:void(0);" class="mobile-menu-expand" @click.stop="toggleDropdown($event, 'Package')">+</a>
              </div>
              <ul class="mobile-sub-menu" v-show="activeDropdown === 'Package'">
                <li class="mobile-sub-menu-item"><a href="javascript:void(0);" class="mobile-sub-menu-link" @click="handleMobileNavClick('/dynamic')">{{ t.serviceDynamic }}</a></li>
              </ul>
            </li>
            <li class="mobile-menu-item">
              <div class="mobile-menu-link-wrapper">
                <a href="/faq" class="mobile-menu-link has-submenu" @click.stop="toggleDropdown($event, 'Tutorial')">{{ t.tutorial }}</a>
                <a href="javascript:void(0);" class="mobile-menu-expand" @click.stop="toggleDropdown($event, 'Tutorial')">+</a>
              </div>
              <ul class="mobile-sub-menu" v-show="activeDropdown === 'Tutorial'">
                <li class="mobile-sub-menu-item"><a href="javascript:void(0);" class="mobile-sub-menu-link" @click="handleMobileNavClick('/faq')">{{ t.faq }}</a></li>
              </ul>
            </li>
            <li class="mobile-menu-item">
              <div class="mobile-menu-link-wrapper">
                <a href="#language" class="mobile-menu-link has-submenu" @click.stop="toggleDropdown($event, 'English')" >{{ languageState.currentLanguage === 'en' ? 'English' : '简体中文' }}</a>
                <a href="javascript:void(0);" class="mobile-menu-expand" @click.stop="toggleDropdown($event, 'English')">+</a>
              </div>
              <ul class="mobile-sub-menu" v-show="activeDropdown === 'English'">
                <li class="mobile-sub-menu-item"><a href="javascript:void(0);" class="mobile-sub-menu-link" @click="setLanguage('en')">English</a></li>
                <li class="mobile-sub-menu-item"><a href="javascript:void(0);" class="mobile-sub-menu-link" @click="setLanguage('zh')">简体中文</a></li>
              </ul>
            </li>
          </ul>
          <div class="mobile-auth-buttons">
            <a href="javascript:void(0);" class="mobile-auth-btn mobile-login-btn" @click="handleMobileNavClick('/login')">{{ t.login }}</a>
            <a href="javascript:void(0);" class="mobile-auth-btn mobile-register-btn" @click="handleMobileNavClick('/register')">{{ t.register }}</a>
          </div>
        </div>
      </div>
    </div>
    <!-- End cyber Main Menu Area -->

    <!-- Banner Section -->
    <section class="faq-banner-section ptb-100">
      <div class="container">
        <div class="banner-content text-center">
          <h1>{{ t.servicePolicyTitle }}</h1>
          <p>{{ t.servicePolicySubtitle }}</p>
        </div>
      </div>
    </section>
    <!-- End Banner Section -->

    <!-- Service Policy Content Section -->
    <section class="policy-content-section ptb-100 bg-light">
      <div class="container">
        <div class="policy-content">
          <div class="policy-header">
            <h2>{{ languageState.currentLanguage === 'en' ? serviceData.title1 : serviceDataZh.title1 }}</h2>
            <div class="policy-meta">
              <span>{{ languageState.currentLanguage === 'en' ? serviceData.title2 : serviceDataZh.title2 }}</span>
              <span>{{ languageState.currentLanguage === 'en' ? serviceData.title3 : serviceDataZh.title3 }}</span>
            </div>
          </div>
          
          <div class="policy-body">
            <div class="policy-section">
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title4 : serviceDataZh.title4 }}</p>
            </div>
            
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? serviceData.title5 : serviceDataZh.title5 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title6 : serviceDataZh.title6 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title7 : serviceDataZh.title7 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title8 : serviceDataZh.title8 }}</p>
            </div>
            
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? serviceData.title9 : serviceDataZh.title9 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title10 : serviceDataZh.title10 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title11 : serviceDataZh.title11 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title12 : serviceDataZh.title12 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title13 : serviceDataZh.title13 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title14 : serviceDataZh.title14 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title15 : serviceDataZh.title15 }}</p>
            </div>
            
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? serviceData.title16 : serviceDataZh.title16 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title17 : serviceDataZh.title17 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title18 : serviceDataZh.title18 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title19 : serviceDataZh.title19 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title20 : serviceDataZh.title20 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title21 : serviceDataZh.title21 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title22 : serviceDataZh.title22 }}</p>
            </div>
            
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? serviceData.title23 : serviceDataZh.title23 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title24 : serviceDataZh.title24 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title25 : serviceDataZh.title25 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title26 : serviceDataZh.title26 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title27 : serviceDataZh.title27 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title28 : serviceDataZh.title28 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title29 : serviceDataZh.title29 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title30 : serviceDataZh.title30 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title31 : serviceDataZh.title31 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title32 : serviceDataZh.title32 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title33 : serviceDataZh.title33 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title34 : serviceDataZh.title34 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title35 : serviceDataZh.title35 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title36 : serviceDataZh.title36 }}</p>
            </div>
            
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? serviceData.title37 : serviceDataZh.title37 }}</h3>
              <h4>{{ languageState.currentLanguage === 'en' ? serviceData.title38 : serviceDataZh.title38 }}</h4>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title39 : serviceDataZh.title39 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title40 : serviceDataZh.title40 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title41 : serviceDataZh.title41 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title42 : serviceDataZh.title42 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title43 : serviceDataZh.title43 }}</p>
              
              <h4>{{ languageState.currentLanguage === 'en' ? serviceData.title44 : serviceDataZh.title44 }}</h4>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title45 : serviceDataZh.title45 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title46 : serviceDataZh.title46 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title47 : serviceDataZh.title47 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title48 : serviceDataZh.title48 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title49 : serviceDataZh.title49 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title50 : serviceDataZh.title50 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title51 : serviceDataZh.title51 }}</p>
              
              <h4>{{ languageState.currentLanguage === 'en' ? serviceData.title52 : serviceDataZh.title52 }}</h4>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title53 : serviceDataZh.title53 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title54 : serviceDataZh.title54 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title55 : serviceDataZh.title55 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title56 : serviceDataZh.title56 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title57 : serviceDataZh.title57 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title58 : serviceDataZh.title58 }}</p>
              
              <h4>{{ languageState.currentLanguage === 'en' ? serviceData.title59 : serviceDataZh.title59 }}</h4>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title60 : serviceDataZh.title60 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title61 : serviceDataZh.title61 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title62 : serviceDataZh.title62 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title63 : serviceDataZh.title63 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title64 : serviceDataZh.title64 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title65 : serviceDataZh.title65 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title66 : serviceDataZh.title66 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title67 : serviceDataZh.title67 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title68 : serviceDataZh.title68 }}</p>
            </div>
            
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? serviceData.title69 : serviceDataZh.title69 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title70 : serviceDataZh.title70 }}</p>
            </div>
            
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? serviceData.title71 : serviceDataZh.title71 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title72 : serviceDataZh.title72 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title73 : serviceDataZh.title73 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title74 : serviceDataZh.title74 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title75 : serviceDataZh.title75 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title76 : serviceDataZh.title76 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title77 : serviceDataZh.title77 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title78 : serviceDataZh.title78 }}</p>
              <h3>{{ languageState.currentLanguage === 'en' ? serviceData.title79 : serviceDataZh.title79 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title80 : serviceDataZh.title80 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title81 : serviceDataZh.title81 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title82 : serviceDataZh.title82 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title83 : serviceDataZh.title83 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title84 : serviceDataZh.title84 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title85 : serviceDataZh.title85 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title86 : serviceDataZh.title86 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title87 : serviceDataZh.title87 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title88 : serviceDataZh.title88 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title89 : serviceDataZh.title89 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title90 : serviceDataZh.title90 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title83 : serviceDataZh.title83 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title84 : serviceDataZh.title84 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title85 : serviceDataZh.title85 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title86 : serviceDataZh.title86 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title87 : serviceDataZh.title87 }}</p>
            </div>
            
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? serviceData.title88 : serviceDataZh.title88 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title89 : serviceDataZh.title89 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title90 : serviceDataZh.title90 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title91 : serviceDataZh.title91 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title92 : serviceDataZh.title92 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title93 : serviceDataZh.title93 }}</p>
            </div>
            
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? serviceData.title94 : serviceDataZh.title94 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title95 : serviceDataZh.title95 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title96 : serviceDataZh.title96 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title97 : serviceDataZh.title97 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title98 : serviceDataZh.title98 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title99 : serviceDataZh.title99 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title100 : serviceDataZh.title100 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title101 : serviceDataZh.title101 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title102 : serviceDataZh.title102 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title103 : serviceDataZh.title103 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title104 : serviceDataZh.title104 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title105 : serviceDataZh.title105 }}</p>
            </div>
            
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? serviceData.title106 : serviceDataZh.title106 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title107 : serviceDataZh.title107 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title108 : serviceDataZh.title108 }}</p>
            </div>
            
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? serviceData.title109 : serviceDataZh.title109 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title110 : serviceDataZh.title110 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title111 : serviceDataZh.title111 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title112 : serviceDataZh.title112 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title113 : serviceDataZh.title113 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title114 : serviceDataZh.title114 }}</p>
            </div>
            
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? serviceData.title115 : serviceDataZh.title115 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title116 : serviceDataZh.title116 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title117 : serviceDataZh.title117 }}</p>
            </div>
            
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? serviceData.title118 : serviceDataZh.title118 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title119 : serviceDataZh.title119 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title120 : serviceDataZh.title120 }}</p>
            </div>
            
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? serviceData.title121 : serviceDataZh.title121 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title122 : serviceDataZh.title122 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title123 : serviceDataZh.title123 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title124 : serviceDataZh.title124 }}</p>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title125 : serviceDataZh.title125 }}</p>
            </div>
            
            <div class="policy-section">
              <h3>{{ languageState.currentLanguage === 'en' ? serviceData.title126 : serviceDataZh.title126 }}</h3>
              <p>{{ languageState.currentLanguage === 'en' ? serviceData.title127 : serviceDataZh.title127 }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Service Policy Content Section -->

    <!-- Footer Area -->
    <div class="footer-middle" id="footer">
      <div class="container">
        <div class="row">
          <!--footer widget 1 -->
          <div class="col-md-6 col-lg-3 col-xs-12">
            <div class="widget widgets_company_info">
              <h2 class="widget-title">IPIPBright</h2>
              <div class="company_info_desc">
                <p>
                  {{ t.footerDesc }}
                </p>
              </div>
              <div class="social_media">
                <h3>{{ t.followUs }}</h3>
                <a href="javascript:void(0);"><i class="fa-brands fa-facebook-f"></i></a>
                <a href="javascript:void(0);"><i class="fa-brands fa-linkedin-in"></i></a>
                <a href="javascript:void(0);"><i class="fa-brands fa-telegram"></i></a>
              </div>
            </div>
          </div>

          <!--footer widget 2 -->
          <div class="col-md-6 col-lg-3 col-xs-12">
            <div id="em_recent_post_widget-8" class="widget widget_recent_data">
              <div class="single-widget-item">
                <h2 class="widget-title">{{ t.quickLinks }}</h2>
                <div class="quick-link-item">
                  <div class="quick-post-text">
                    <h4>
                      <i class="fa fa-angle-right"></i
                      ><a href="/"> {{ t.home }} </a>
                    </h4>
                  </div>
                </div>
                <div class="quick-link-item">
                  <div class="quick-post-text">
                    <h4>
                      <i class="fa fa-angle-right"></i
                      ><a href="/privacy"> {{ t.privacyPolicy }} </a>
                    </h4>
                  </div>
                </div>
                <div class="quick-link-item">
                  <div class="quick-post-text">
                    <h4>
                      <i class="fa fa-angle-right"></i
                      ><a href="/service-policy"> {{ t.servicePolicy }} </a>
                    </h4>
                  </div>
                </div>
                <div class="quick-link-item">
                  <div class="quick-post-text">
                    <h4>
                      <i class="fa fa-angle-right"></i
                      ><a href="/faq"> {{ t.faq }} </a>
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--footer widget 3 -->
          <div class="col-md-6 col-lg-3 col-xs-12">
            <div id="em_recent_post_widget-7" class="widget widget_recent_data">
              <div class="single-widget-item">
                <h2 class="widget-title">{{ t.productServices }}</h2>
                <div class="quick-link-item">
                  <div class="quick-post-text">
                    <h4>
                      <i class="fa fa-angle-right"></i
                      ><a href="/dynamic"> {{ t.serviceDynamic }} </a>
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--footer widget 4 -->
          <div class="col-lg-3 col-md-6 col-xs-12 last">
            <div class="widget widget_get_quote">
              <h2 class="widget-title">{{ t.contactUs }}</h2>
              <div class="widget_get_quote_content">
                <div class="widget_quote_text">
                  <div class="footer_quote_text_decripsition">
                    <div class="footer_quote_decripsition_inner">
                      <p>
                        {{ t.supportText }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Footer Area -->
    
    <!-- Footer Bottom Area -->
    <div class="footer-bottom">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="footer-bottom-content">
              <p>{{ t.copyright }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Footer Bottom Area -->

    <!-- Simple go to top button -->
    <div 
      id="simple-go-top" 
      @click="scrollToTop"
      style="
        position: fixed;
        bottom: 30px;
        right: 30px;
        width: 55px;
        height: 55px;
        background: linear-gradient(135deg, #1581c6, #1581c6);
        color: white;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        z-index: 9999999;
        font-size: 26px;
        font-weight: bold;
        box-shadow: 0 8px 25px rgba(21, 129, 198, 0.6);
        transition: all 0.3s ease;
        opacity: 0;
        visibility: hidden;
        border: none;
      "
    >
      ↑
    </div>
  </div>
</template>

<script>
export default {
  name: 'ServicePolicy',
  inject: ['changeLanguage', 'languageState'],
  data() {
    return {
      // 页面文本国际化配置
      i18n: {
        en: {
            home: 'Home',
            services: 'Package',
            serviceDynamic: 'Dynamic residence',
            serviceStatic: 'Static residence',
            blog: 'Tutorial Center',
            tutorial: 'Tutorial',
            faq: 'FAQs',
            signIn: 'Sign In',
            signUp: 'Sign Up',
            login: 'Login',
            register: 'Register',
            learnMore: 'Buy Now',
            servicePolicyTitle: 'Service Policy',
            servicePolicySubtitle: 'Learn about our service terms and conditions',
            footerDesc: 'Your trusted partner for high-quality proxy services with global coverage and exceptional performance.',
            quickLinks: 'Quick Links',
            productServices: 'Product Services',
            contactUs: 'Contact Us',
            supportText: '24/7 technical support, ready to answer your questions and provide professional IP proxy solutions.',
            copyright: 'ipipbright. © 2024 All Rights Reserved.',
            privacyPolicy: 'Privacy Policy',
            servicePolicy: 'Service Policy',
            followUs: 'Follow Us'
          },
          zh: {
            home: '首页',
            services: '动态套餐',
            serviceDynamic: '动态住宅',
            serviceStatic: '静态住宅',
            blog: '教程中心',
            tutorial: '教程中心',
            faq: '常见问题',
            signIn: '登录',
            signUp: '注册',
            login: '登录',
            register: '注册',
            learnMore: '立即购买',
            servicePolicyTitle: '服务政策',
            servicePolicySubtitle: '了解我们的服务条款和条件',
            footerDesc: '您值得信赖的高质量代理服务合作伙伴，提供全球覆盖和卓越性能。',
            quickLinks: '快速链接',
            productServices: '产品服务',
            contactUs: '联系我们',
            supportText: '24/7技术支持，随时为您解答问题，提供专业的IP代理解决方案。',
            copyright: 'ipipbright. © 2024 保留所有权利。',
            privacyPolicy: '隐私政策',
            servicePolicy: '服务政策',
            followUs: '关注我们'
          }
      },
      isSticky: false,
      isNavCollapsed: true,
      isMobileMenuOpen: false,
      activeDropdown: '',
      showGoTop: false,
      // 服务政策数据
      serviceData: {
        title1: 'ipipbright user service agreement',
        title2: 'The latest update time of the agreement: July 15, 2023',
        title3: 'Agreement effective date: July 15, 2023',
        title4: "The ipipbright user service agreement is between the user ('you') and Jiangsu Aidi Information Technology Co., Ltd. (hereinafter referred to as 'Aidi' or 'we') on ipipbright's official website (www.ipipbright.net, 'this website') ) services and other related matters, please read it carefully. If you indicate your acceptance of this agreement by checking, clicking to confirm, or otherwise indicating your acceptance of this agreement, or if you use the ipipbright service in any way, you will be deemed to have fully read it. Understand and agree to be bound by this agreement, and this agreement will have legal effect between you and ipipbright.",
        title5: 'Article 1 General Provisions',
        title6: '1.1 Before using this service, you have fully read, understood and accepted all the contents of these Terms of Service (especially the highlighted contents). Once you select "Agree" and complete account registration or use this service, it means that you agree to abide by the terms of service. All agreements in these Terms of Service. Your use of ipipbright services will be deemed as your acknowledgment of the entire contents of this Agreement and the "ipipbright Privacy Agreement".',
        title7: '1.2 You agree: ipipbright reserves the right to update this agreement and the corresponding service rules at any time. If ipipbright updates this appendix, ipipbright will notify you by publishing an announcement on its official website. If you do not agree to the changes, you have the right to terminate your use of this service before the effective date of the new agreement or service rules. If you continue to use this service after the effective date of the new agreement or service rules, you will be deemed to have accepted the new agreement or service rules and waived your right to terminate the service in accordance with this article.',
        title8: "1.3 When you complete account registration or actually use the service in other ways permitted by ipipbright, you should be a legal subject with full civil rights and full civil capacity. If you do not have the aforementioned civil capacity appropriate to your behavior, you should obtain the informed consent of your legal guardian. If you are under age, please read and determine whether you agree to this agreement with the company of your legal guardian. The minor's exercise and performance of the rights and obligations under this Agreement shall be deemed to have been recognized by the legal guardian.",
        title9: 'Article 2 Scope of Agreement',
        title10: "2.1 This agreement is an agreement between the user and ipipbright regarding the use of ipipbright's services. 'ipipbright' refers to the operating affiliated units that may exist for ipipbright and/or its related services. 'User' refers to the user/enterprise of ipipbright's services (including but not limited to registered users, free users, third-party channel login users and users affiliated with partners and agents), and is more commonly referred to as 'users' in this agreement. you'.",
        title11: '2.2 The services of ipipbright refer to the services provided by ipipbright to you. The specific services are subject to those actually provided by ipipbright (hereinafter referred to as the "service").',
        title12: "2.3 The content of this agreement also includes the 'ipipbright Privacy Agreement', and when you use a specific ipipbright service, that service may have a separate agreement, relevant business rules, etc. (hereinafter collectively referred to as the 'separate agreement'). Once the above content is officially released, it will become an integral part of this Agreement and you shall also abide by it. Your acceptance of any of the foregoing separate agreements shall be deemed your acceptance of this Agreement in its entirety. Your acceptance of this agreement shall be deemed as your acceptance of the 'ipipbright Privacy Agreement'.",
        title13: '2.4 ipipbright is only responsible for the scope of liability specified in these Terms of Service.',
        title14: '2.5 ipipbright shall not be liable for any indirect, punitive, special, derivative losses (including business losses, income losses, profit losses, usage data, goodwill, etc.) caused by breach of contract, infringement, etc. related to or arising from these Terms of Service. or other economic loss), regardless of how it arises, shall not be liable for any loss, even if it has been informed in advance of the possibility of such losses.',
        title15: 'Article 3 Account and Password Security',
        title16: '3.1 In order to use the ipipbright service, you need to register a ipipbright account (hereinafter referred to as the "account"). After you fill in the information as prompted on the registration page, read and agree to these Terms of Service, and complete the registration, or when you actually use the services of this website in other ways permitted by ipipbright, you will be bound by these Terms of Service.',
        title17: '3.2 You should have the necessary and appropriate rights and capacity in accordance with the law, and have granted the operator sufficient rights to complete the registration process. You promise that the registration information you provide is true, accurate, complete, legal and valid. If your registration information changes, you should update the registration information in a timely manner. You shall bear full responsibility for all actions under the registered ipipbright account and shall not infringe upon the legitimate rights and interests of any party, including but not limited to ipipbright.',
        title18: '3.3 You understand and agree: To ensure the security of your account and transactions, ipipbright has the right to require you to complete the real-name authentication of your ipipbright account at any time; only after your account passes these authentications and verifications, can you be qualified to use ipipbright related services.',
        title19: '3.4 You agree or accept: When necessary, we have the right to use your registration information, username, password and other information to log in to your registered account for evidence preservation, including but not limited to notarization, witnessing, etc.',
        title20: '3.5 The ipipbright account is limited to your own use. You may not provide your account to others in any way without the consent of ipipbright. You are responsible for the actions under your account. All operations under your account are deemed to be performed by you, and you shall bear all legal consequences.',
        title21: '3.6 ipipbright specifically reminds you to keep your account and password properly. When you are done using it, you should exit safely. Your account may be compromised or your password may be stolen due to poor storage, and you shall be solely responsible for this.',
        title22: 'Article 4 Privacy and Protection of Other Users\' Personal Information',
        title23: '4.1 Protecting users\' personal information is a basic principle of ipipbright. ipipbright will collect, use and store your personal information in accordance with the provisions of this agreement and the "ipipbright privacy agreement". If this agreement does not clearly stipulate the protection of personal information, the contents of the "ipipbright privacy agreement" shall prevail.',
        title24: '4.2 When you register an account or use this service, you need to fill in some necessary information (mobile phone number or identity information). According to national laws and regulations, you need to fill in your true identity information. If the information you fill in is incomplete, you may not be able to use this service or may be restricted during use.',
        title25: '4.3 Under normal circumstances, you can browse and modify the information you submitted according to relevant product rules, but for security and identity recognition reasons, you cannot modify the real-name authentication information.',
        title26: '4.4 ipipbright promises to keep your information confidential in accordance with the "ipipbright Privacy Agreement", not to disclose your information to third parties, and not to authorize third parties to use your information unless:',
        title27: '(1) It can be provided in accordance with this user agreement or other documents between you and ipipbright;',
        title28: '(2) It should be provided in accordance with the provisions of laws and regulations;',
        title29: '(3) Administrative, judicial and other relevant national departments require ipipbright to provide;',
        title30: '(4) You agree that ipipbright will provide it to third parties;',
        title31: '(5) Submitted by ipipbright to resolve reported incidents and file lawsuits;',
        title32: '(6) ipipbright must submit necessary and reasonable measures to prevent the occurrence of violations of laws and regulations and criminal acts;',
        title33: '(7) ipipbright provides products, services, and information to third parties in order to provide you with products, services, and information, including situations where ipipbright provides products, services, and information to you through third-party technologies and services.',
        title34: '4.5 ipipbright only provides corresponding security measures based on existing technologies to prevent the information managed by ipipbright from being lost, but ipipbright does not promise to guarantee the absolute security of this information.',
        title35: '4.6 You agree: In order to better provide you with services, we may send you order information, promotions, etc. through emails, text messages, phone calls, etc. from time to time based on the information you provide, while ensuring that you are The right to be informed.',
        title36: 'Article 5 Services',
        title37: '5.1 How to use this service',
        title38: '5.1.1 The rights you obtain under the terms of this Agreement are only enjoyed by you and are not transferable.',
        title39: '5.1.2 You may not use any means (including but not limited to third-party software, plug-ins, systems, equipment, etc.) to interfere, destroy, modify or exert other influence on this service.',
        title40: '5.1.3 You should use this service through the methods provided or recognized by ipipbright.',
        title41: '5.1.4 You should understand that when using this service, you need to prepare your own terminal equipment related to the relevant services (such as computers, mobile terminals, necessary network access equipment, etc.), and bear the required expenses (such as telephone charges, Internet access, etc.) fees, etc.).',
        title42: '5.1.5 You understand and agree that when you use this service, your terminal equipment, bandwidth and other resources will be consumed.',
        title43: '5.2 Service fees',
        title44: '5.2.1 ipipbright may modify and change the charging standards and methods of paid services based on actual needs, and ipipbright may also start charging for some free services. Before the aforementioned modifications, changes or the start of charging, ipipbright will notify or announce on the official website. If you do not agree to the above modifications, changes or paid content, you should stop using the service.',
        title45: '5.2.2 When ipipbright reduces the charging standards of paid services or changes the paid services to free services, ipipbright reserves the right not to provide refunds or fee adjustments to original paying users.',
        title46: '5.2.3 You know and agree that if one of the following circumstances occurs, ipipbright will freeze part or all of the funds in your account:',
        title47: '(1) Provisions of national laws, policies, regulations, and effective legal documents;',
        title48: '(2) Relevant national competent authorities require freezing;',
        title49: '(3) Your use of ipipbright services is suspected of violating national laws and regulations;',
        title50: '(4) You have been complained by others, and the other party has provided preliminary evidence, so that ipipbright has reason to believe that the complaint exists;',
        title51: '(5) Other situations that ipipbright believes may create risks based on its own reasonable judgment.',
        title52: '5.3 Services are provided as is',
        title53: 'You understand and agree:',
        title54: '(1) This service is provided according to the status quo that the existing technology and conditions can achieve. ipipbright will do its best to ensure the continuity and security of the service, but ipipbright cannot foresee and prevent legal, technical and other risks at any time. ipipbright is exempt from liability for such risks to the extent permitted by law, including but not limited to force majeure, viruses, and Trojans. , hacker attacks, system instability, third-party service defects, government actions and other reasons that may cause service interruption, data loss and other losses and risks.',
        title55: '(2) ipipbright may make product or service adjustments based on business strategies or other development needs. The content of specific ipipbright services available to users in different regions may be different. The actual content provided by ipipbright shall prevail.',
        title56: '(3) The ipipbright service price, quantity, availability and other information are subject to change at any time, and we will not make special notifications about this. We will do our best to ensure the accuracy of the information you browse on the ipipbright official website. However, due to well-known Internet technical factors and other objective reasons, the information displayed on the ipipbright official website may have certain lags or errors. In this case, you Know and understand that when using ipipbright services, the actual situation shall prevail.',
        title57: "(4) Unless otherwise expressly stated in writing, all information, content, materials, products or services we provide to you are provided on an 'as is' and 'as available' basis. Unless otherwise expressly stated in writing, we make no representations or warranties of any kind, express or implied, as to the operation of this website and the information, content, materials, products or services contained on this website (in accordance with the laws of the People's Republic of China Unless otherwise specified).",
        title58: '(5) We do not guarantee that all the information, content, materials, products and services contained in this website or otherwise provided to you through this website, its servers or electronic letters and information sent from this website are free of viruses or other harmful Element. If the sales system of this site crashes or cannot be used normally due to force majeure or other reasons beyond the control of this site, resulting in the inability to complete online transactions or the loss of relevant information, records, etc., we will reasonably try our best to assist in handling the aftermath.',
        title59: '5.4 Service suspension, change and termination',
        title60: '5.4.1 You understand and agree that in order to provide you with more complete services, ipipbright may conduct routine and planned maintenance, which may result in a short-term interruption or suspension of the services you are using. Based on adjustments to business strategies, ipipbright may Changes to service content may also lead to service interruption or termination. ipipbright does not assume any responsibility to you for service interruption or suspension caused by such maintenance.',
        title61: '5.4.2 ipipbright has the right to charge fees as stipulated in this agreement. If you fail to pay in full and on time, ipipbright has the right to interrupt, suspend or terminate the service.',
        title62: '5.4.3 You are responsible for backing up the data stored in the Service yourself. If your service is terminated, ipipbright has the right to permanently seal your data from the server, unless otherwise provided by laws and regulations. After the service is suspended or terminated, ipipbright has no obligation to provide or return data to you.',
        title63: '5.4.4 When ipipbright undergoes a merger, division, acquisition, or asset transfer, ipipbright may transfer the relevant assets under this service to a third party; ipipbright may also transfer some or all of the services and corresponding rights and obligations under this agreement to you after unilaterally notifying you. Transfers are operated or performed by third parties. The specific transferee shall be subject to the notice of ipipbright.',
        title64: '5.4.5 If any of the following circumstances occurs, ipipbright has the right to interrupt or terminate services to you without notice:',
        title65: '(1) According to laws and regulations, administrative regulations, or the requirements of relevant national competent authorities;',
        title66: '(2) Your use of this service violates relevant laws and regulations or the provisions of this Agreement;',
        title67: '(3) Your behavior violates social public interests or public morality;',
        title68: '(4) Your account is subject to complaints, reports, or third-party rights claims, which ipipbright has reason to believe may cause losses to ipipbright or third parties;',
        title69: 'Article 6 User Obligations',
        title70: '6.1 You must comply with national laws, regulations, rules, policies, social morality and the provisions of this agreement when using ipipbright services. You must not use ipipbright services to engage in any illegal or infringing activities, including but not limited to:',
        title71: '(1) Violating national laws and regulations, harming national security, leaking state secrets, subverting state power, undermining national unity, disrupting social order, promoting邪教 and feudal superstition;',
        title72: '(2) Producing, reproducing, publishing, and disseminating information that contains obscenity, pornography, violence, terror, or instigates ethnic hatred, ethnic discrimination;',
        title73: '(3) Infringing upon the intellectual property rights or other legitimate rights and interests of others, such as copyrights, patents, trademarks, trade secrets, etc.;',
        title74: '(4) Fabricating or spreading false information, disrupting economic order and social order;',
        title75: '(5) Engaging in pyramid schemes, fraud, gambling and other illegal activities;',
        title76: '(6) Other acts that violate laws, regulations, rules, policies, social morality or the provisions of this agreement.',
        title77: '6.2 You shall bear full responsibility for all acts under your ipipbright account. If your use of ipipbright services causes losses to ipipbright or third parties, you shall bear corresponding legal responsibilities.',
        title78: '6.3 You shall properly keep your ipipbright account and password, and shall not disclose them to others. If your account or password is stolen or used by others, you shall immediately notify ipipbright, and ipipbright will take appropriate measures according to the actual situation.',
        title79: 'Article 7 Intellectual Property Rights',
        title80: '7.1 All intellectual property rights related to ipipbright services (including but not limited to software, text, images, audio, video, logos, trademarks, etc.) belong to ipipbright or its licensors. You shall not infringe upon these intellectual property rights in any way.',
        title81: '7.2 You agree that ipipbright has the right to use, reproduce, modify, adapt, publish, translate, distribute, execute and display your user information, feedback, suggestions and other content, or to incorporate them into other works, in any form, media or technology now known or hereafter developed, without compensation to you.',
        title82: '7.3 You shall ensure that the content you publish or transmit through ipipbright services does not infringe upon the intellectual property rights of others. If you infringe upon the intellectual property rights of others, you shall bear corresponding legal responsibilities, and ipipbright has the right to remove the infringing content and take measures such as suspending or terminating your account.',
        title83: 'Article 8 Disclaimer',
        title84: '8.1 ipipbright will do its best to ensure the normal operation of the service, but ipipbright does not guarantee that the service is error-free, uninterrupted, or that the service is completely safe. You use ipipbright services at your own risk.',
        title85: '8.2 ipipbright shall not be liable for any direct or indirect losses caused by force majeure, such as natural disasters, wars, government actions, etc.',
        title86: '8.3 ipipbright shall not be liable for any losses caused by your own reasons, such as improper account management, improper operation, etc.',
        title87: '8.4 ipipbright shall not be liable for any losses caused by third parties, such as third-party website failures, network attacks, etc.',
        title88: '8.5 ipipbright shall not be liable for any losses caused by your violation of this agreement or relevant laws and regulations.',
        title89: 'Article 9 Dispute Resolution',
        title90: '9.1 The conclusion, performance, interpretation and dispute resolution of this agreement shall be governed by the laws of the People\'s Republic of China.',
        title91: '9.2 Any dispute arising from or in connection with this agreement shall be resolved through friendly negotiation between the parties. If the negotiation fails, either party may file a lawsuit in the people\'s court with jurisdiction over the place where ipipbright is located.',
        title92: '9.3 During the dispute resolution process, the parties shall continue to perform the parts of this agreement that are not in dispute.',
        title93: 'Article 10 Other Provisions',
        title94: '10.1 If any provision of this agreement is deemed invalid or unenforceable by a court of competent jurisdiction, the validity and enforceability of other provisions of this agreement shall not be affected.',
        title95: '10.2 The failure of ipipbright to exercise or enforce any right or provision of this agreement shall not constitute a waiver of such right or provision.',
        title96: '10.3 ipipbright has the right to assign all or part of its rights and obligations under this agreement to a third party. In this case, ipipbright will notify you in an appropriate manner.',
        title97: '10.4 The headings of each article of this agreement are for convenience of reading only and do not affect the interpretation of the content of this agreement.',
        title98: '10.5 This agreement is the complete agreement between you and ipipbright regarding ipipbright services, and supersedes all previous oral or written agreements, understandings and communications between the parties regarding ipipbright services.',
        title99: '10.6 If you have any questions or suggestions about this agreement, you may contact ipipbright customer service.',
        title100: 'Article 11 Changes to the Agreement',
        title101: '11.1 ipipbright reserves the right to modify this agreement at any time. Once the content of this agreement is changed, ipipbright will publish the changed agreement on the official website. You can check the latest agreement content on the official website.',
        title102: '11.2 If you do not agree to the changed agreement, you should stop using ipipbright services immediately. If you continue to use ipipbright services after the agreement is changed, you will be deemed to have accepted the changed agreement.',
        title103: 'Article 12 Effective Date',
        title104: '12.1 This agreement shall come into effect on the date you register an account or actually use ipipbright services in other ways permitted by ipipbright.',
        title105: '12.2 This agreement shall remain in effect until you terminate your use of ipipbright services or ipipbright terminates the provision of services to you.',
        title106: 'Article 13 Contact Information',
        title107: '13.1 If you have any questions about this agreement or ipipbright services, you may contact ipipbright customer service through the following methods:',
        title108: 'Email: super@ipipbright.net',
        title109: 'Article 14 Severability',
        title110: '14.1 If any provision of this Agreement is held to be invalid or unenforceable by a court of competent jurisdiction, the remaining provisions of this Agreement shall remain in full force and effect.',
        title111: '14.2 The invalidity or unenforceability of any provision of this Agreement shall not affect the validity or enforceability of any other provision of this Agreement.',
        title112: 'Article 15 Entire Agreement',
        title113: '15.1 This Agreement constitutes the entire agreement between you and ipipbright regarding the subject matter hereof and supersedes all prior and contemporaneous understandings, agreements, representations and warranties, both written and oral, regarding the subject matter hereof.',
        title114: '15.2 No modification to this Agreement shall be effective unless it is in writing and signed by both parties or published by ipipbright on the official website.',
        title115: 'Article 16 Governing Law',
        title116: '16.1 This Agreement shall be governed by and construed in accordance with the laws of the People\'s Republic of China.',
        title117: '16.2 Any dispute arising out of or in connection with this Agreement shall be submitted to the people\'s court with jurisdiction over the place where ipipbright is located for settlement.',
        title118: 'Article 17 Notice',
        title119: '17.1 Any notice or communication required or permitted to be given under this Agreement shall be in writing and shall be deemed to have been duly given when delivered in person, sent by registered mail, or sent by email to the address provided by the other party.',
        title120: '17.2 If you change your contact information, you shall notify ipipbright in a timely manner. ipipbright shall not be liable for any losses caused by your failure to update your contact information in a timely manner.',
        title121: 'Article 18 Waiver',
        title122: '18.1 The failure of ipipbright to exercise or enforce any right or provision of this Agreement shall not constitute a waiver of such right or provision.',
        title123: '18.2 A waiver by ipipbright of any default shall not constitute a waiver of any subsequent default.',
        title124: '18.3 No waiver of any provision of this Agreement shall be effective unless it is in writing and signed by ipipbright.',
        title125: 'Article 19 Assignment',
        title126: '19.1 You may not assign any of your rights or obligations under this Agreement to any third party without the prior written consent of ipipbright.',
        title127: '19.2 ipipbright may assign all or part of its rights and obligations under this Agreement to a third party without your consent, but ipipbright will notify you of such assignment in an appropriate manner.'
      },
      serviceDataZh: {
        title1: 'ipipbright 用户服务协议',
        title2: '协议最新更新时间：2023年7月15日',
        title3: '协议生效日期：2023年7月15日',
        title4: "《ipipbright 用户服务协议》是用户（'您'）与江苏艾迪信息技术有限公司（以下简称'艾迪'或'我们'）就 ipipbright 官方网站（www.ipipbright.net，'本网站'）服务等相关事项所订立的协议，请您仔细阅读。如果您通过勾选、点击确认或以其他方式表示接受本协议，或您以任何方式使用 ipipbright 服务，即视为您已完全阅读、理解并同意受本协议约束，本协议将在您与 ipipbright 之间产生法律效力。",
        title5: '第一条 总则',
        title6: '1.1 在使用本服务前，您已完全阅读、理解并接受本服务条款的所有内容（特别是以高亮方式提示的内容）。一旦您选择"同意"并完成账号注册或使用本服务，即表示您同意遵守本服务条款中的所有协议。您对 ipipbright 服务的使用将被视为您对本协议及《ipipbright 隐私协议》全部内容的确认。',
        title7: '1.2 您同意：ipipbright 保留随时更新本协议及相应服务规则的权利。如果 ipipbright 更新本附录，ipipbright 将通过在其官方网站发布公告的方式通知您。如果您不同意修改，您有权在新协议或服务规则生效前终止使用本服务。如果您在新协议或服务规则生效后继续使用本服务，即视为您接受新的协议或服务规则，并放弃依照本条终止服务的权利。',
        title8: '1.3 当您完成账号注册或通过 ipipbright 允许的其他方式实际使用服务时，您应是具有完全民事权利能力和完全民事行为能力的法律主体。如果您不具备与您行为相适应的前述民事行为能力，应获得您法定监护人的知情同意。如果您是未成年人，请在您的法定监护人的陪同下阅读并决定是否同意本协议。未成年人行使和履行本协议项下的权利和义务，应视为已获得法定监护人的认可。',
        title9: '第二条 协议范围',
        title10: '2.1 本协议是用户与 ipipbright 之间关于使用 ipipbright 服务的协议。"ipipbright" 指 ipipbright 可能存在的运营关联单位及/或其相关服务的运营主体。"用户"指 ipipbright 服务的使用者/企业（包括但不限于注册用户、免费用户、第三方渠道登录用户以及合作伙伴和代理商的关联用户），在本协议中更多地称为"用户"。你。',
        title11: '2.2 ipipbright 的服务指 ipipbright 向您提供的服务。具体服务以 ipipbright 实际提供的为准（以下简称"服务"）。',
        title12: '2.3 本协议的内容还包括《ipipbright 隐私协议》，当您使用特定的 ipipbright 服务时，该服务可能有单独的协议、相关业务规则等（以下统称为"单独协议"）。上述内容一经正式发布，即构成本协议的组成部分，您应当一并遵守。您接受前述任何单独协议，即视为您已完整接受本协议。您接受本协议，即视为您已接受《ipipbright 隐私协议》。',
        title13: '2.4 ipipbright 仅对本服务条款中规定的责任范围负责。',
        title14: '2.5 ipipbright 不对因违反合同、侵权等与本服务条款相关或由本服务条款引起的任何间接、惩罚性、特殊、衍生性损失（包括业务损失、收入损失、利润损失、使用数据、商誉等）或其他经济损失承担责任，无论其如何产生，即使事先已被告知可能发生此类损失，也不承担任何责任。',
        title15: '第三条 账号与密码安全',
        title16: '3.1 为使用 ipipbright 服务，您需要注册一个 ipipbright 账号（以下简称"账号"）。在您按照注册页面提示填写信息、阅读并同意本服务条款并完成注册后，或当您以 ipipbright 允许的其他方式实际使用本网站服务时，您将受本服务条款的约束。',
        title17: '3.2 您应当依法具备必要和适当的权利和行为能力，并已赋予经营者完成注册过程的充分权利。您承诺您提供的注册信息真实、准确、完整、合法有效。如果您的注册信息发生变化，您应当及时更新注册信息。您应对注册的 ipipbright 账号下的所有行为承担全部责任，不得侵犯任何一方的合法权益，包括但不限于 ipipbright。',
        title18: '3.3 您理解并同意：为确保您的账户和交易安全，ipipbright 有权随时要求您完成 ipipbright 账户的实名认证；只有当您的账户通过这些认证和验证后，您才有资格使用 ipipbright 相关服务。',
        title19: '3.4 您同意或接受：必要时，我们有权使用您的注册信息、用户名、密码等信息登录您的注册账户进行证据保全，包括但不限于公证、见证等。',
        title20: '3.5 ipipbright 账号仅限您本人使用。未经 ipipbright 同意，您不得以任何方式将您的账号提供给他人使用。您对账号下的行为负责。您账号下的所有操作均视为您本人所为，您应承担全部法律后果。',
        title21: '3.6 ipipbright 特别提醒您妥善保管您的账号和密码。使用完毕后，应安全退出。因保管不善导致账号被盗或密码被窃取，您应自行承担全部责任。',
        title22: '第四条 隐私与其他用户个人信息保护',
        title23: '4.1 保护用户个人信息是 ipipbright 的基本原则。ipipbright 将根据本协议和《ipipbright 隐私协议》的规定收集、使用和存储您的个人信息。如果本协议未明确规定个人信息保护内容，则以《ipipbright 隐私协议》的内容为准。',
        title24: '4.2 当您注册账号或使用本服务时，您需要填写一些必要信息（手机号码或身份信息）。根据国家法律法规，您需要填写真实身份信息。如果您填写的信息不完整，您可能无法使用本服务或在使用过程中受到限制。',
        title25: '4.3 正常情况下，您可以根据相关产品规则浏览和修改您提交的信息，但出于安全和身份识别原因，您无法修改实名认证信息。',
        title26: '4.4 ipipbright 承诺根据《ipipbright 隐私协议》对您的信息保密，不向第三方披露您的信息，也不授权第三方使用您的信息，除非：',
        title27: '(1) 可根据本用户协议或您与 ipipbright 之间的其他文件提供；',
        title28: '(2) 应根据法律法规的规定提供；',
        title29: '(3) 行政、司法等相关国家部门要求 ipipbright 提供；',
        title30: '(4) 您同意 ipipbright 将其提供给第三方；',
        title31: '(5) 由 ipipbright 提交以解决举报事件和提起诉讼；',
        title32: '(6) ipipbright 必须提交必要和合理的措施以防止发生违反法律法规和犯罪行为；',
        title33: '(7) ipipbright 为向您提供产品、服务和信息而向第三方提供产品、服务和信息，包括 ipipbright 通过第三方技术和服务向您提供产品、服务和信息的情况。',
        title34: '4.5 ipipbright 仅根据现有技术提供相应的安全措施，防止 ipipbright 管理的信息丢失，但 ipipbright 不承诺保证该信息的绝对安全。',
        title35: '4.6 您同意：为了更好地为您提供服务，我们可能会根据您提供的信息，通过电子邮件、短信、电话等方式不时向您发送订单信息、促销活动等，同时确保您享有知情权。',
        title36: '第五条 服务',
        title37: '5.1 如何使用本服务',
        title38: '5.1.1 您根据本协议获得的权利仅由您享有，不得转让。',
        title39: '5.1.2 您不得使用任何手段（包括但不限于第三方软件、插件、系统、设备等）干扰、破坏、修改或对本服务施加其他影响。',
        title40: '5.1.3 您应通过 ipipbright 提供或认可的方式使用本服务。',
        title41: '5.1.4 您应理解，使用本服务时，您需要自备与相关服务相关的终端设备（如计算机、移动终端、必要的网络接入设备等），并承担所需的费用（如电话费、上网费等）。',
        title42: '5.1.5 您理解并同意，使用本服务时，您的终端设备、带宽等资源将被消耗。',
        title43: '5.2 服务费用',
        title44: '5.2.1 ipipbright 可根据实际需要修改和变更付费服务的收费标准和方式，ipipbright 也可能对某些免费服务开始收费。在前述修改、变更或开始收费前，ipipbright 将在官方网站上通知或公告。如果您不同意上述修改、变更或付费内容，您应停止使用该服务。',
        title45: '5.2.2 当 ipipbright 降低付费服务的收费标准或将付费服务变更为免费服务时，ipipbright 保留不对原付费用户提供退款或费用调整的权利。',
        title46: '5.2.3 您知悉并同意，如发生下列情形之一，ipipbright 将冻结您账户中的部分或全部资金：',
        title47: '(1) 国家法律、政策、法规和有效法律文件的规定；',
        title48: '(2) 相关国家主管部门要求冻结；',
        title49: '(3) 您使用 ipipbright 服务涉嫌违反国家法律法规；',
        title50: '(4) 您被他人投诉，且对方已提供初步证据，使 ipipbright 有理由相信投诉存在；',
        title51: '(5) ipipbright 根据自身合理判断认为可能产生风险的其他情况。',
        title52: '5.3 服务按现状提供',
        title53: '您理解并同意：',
        title54: '(1) 本服务是根据现有技术和条件所能达到的现状提供的。ipipbright 将尽最大努力确保服务的连续性和安全性，但 ipipbright 不能随时预见和防范法律、技术等风险。在法律允许的范围内，ipipbright 对因此类风险造成的损失不承担责任，包括但不限于不可抗力、病毒、木马、黑客攻击、系统不稳定、第三方服务缺陷、政府行为等可能导致服务中断、数据丢失等损失和风险。',
        title55: '(2) ipipbright 可能根据业务战略或其他发展需要对产品或服务进行调整。不同地区的用户可使用的具体 ipipbright 服务内容可能不同。以 ipipbright 实际提供的内容为准。',
        title56: '(3) ipipbright 服务价格、数量、可用性等信息随时可能发生变化，我们对此不做特别通知。我们将尽最大努力确保您在 ipipbright 官方网站上浏览的信息准确无误。但由于众所周知的互联网技术因素和其他客观原因，ipipbright 官方网站上显示的信息可能存在一定的滞后性或错误。在此情况下，您知悉并理解，使用 ipipbright 服务时，以实际情况为准。',
        title57: '(4) 除非另有书面明确说明，我们向您提供的所有信息、内容、材料、产品或服务均按"现状"和"可用"提供。除非另有书面明确说明，我们不对本网站的运营以及本网站上包含的信息、内容、材料、产品或服务作出任何形式的明示或暗示的陈述或保证（根据中华人民共和国法律另有规定的除外）。',
        title58: '(5) 我们不保证本网站或通过本网站、其服务器或从本网站发送的电子信件和信息中包含的所有信息、内容、材料、产品和服务均不含病毒或其他有害元素。如果因不可抗力或本网站无法控制的其他原因导致本网站销售系统崩溃或无法正常使用，导致无法完成在线交易或丢失相关信息、记录等，我们将合理尽力协助处理善后事宜。',
        title59: '5.4 服务暂停、变更和终止',
        title60: '5.4.1 您理解并同意，为了向您提供更完整的服务，ipipbright 可能会进行例行和计划内的维护，这可能导致您正在使用的服务短暂中断或暂停。基于业务战略调整，ipipbright 也可能对服务内容进行变更，从而导致服务中断或终止。对于因此类维护导致的服务中断或暂停，ipipbright 不对您承担任何责任。',
        title61: '5.4.2 ipipbright 有权按照本协议规定收取费用。如果您未按时足额支付，ipipbright 有权中断、暂停或终止服务。',
        title62: '5.4.3 您自行负责备份存储在服务中的数据。如果您的服务被终止，ipipbright 有权将您的数据从服务器中永久封存，法律法规另有规定的除外。服务暂停或终止后，ipipbright 没有义务向您提供或返还数据。',
        title63: '5.4.4 当 ipipbright 进行合并、分立、收购或资产转让时，ipipbright 可将本服务下的相关资产转让给第三方；ipipbright 也可在单方面通知您后，将本协议项下的部分或全部服务及相应权利义务转让给第三方运营或履行。具体受让方以 ipipbright 的通知为准。',
        title64: '5.4.5 如发生下列情形之一，ipipbright 有权在不通知您的情况下中断或终止向您提供服务：',
        title65: '(1) 根据法律法规、行政法规或相关国家主管部门的要求；',
        title66: '(2) 您使用本服务违反相关法律法规或本协议的规定；',
        title67: '(3) 您的行为违反社会公共利益或公共道德；',
        title68: '(4) 您的账户受到投诉、举报或第三方权利主张，ipipbright 有理由相信可能对 ipipbright 或第三方造成损失；',
        title69: '第六条 用户义务',
        title70: '6.1 您在使用 ipipbright 服务时，必须遵守国家法律法规、规则、政策、社会公德和本协议的规定。您不得利用 ipipbright 服务从事任何违法或侵权活动，包括但不限于：',
        title71: '(1) 违反国家法律法规，危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一，扰乱社会秩序，宣扬邪教和封建迷信；',
        title72: '(2) 制作、复制、发布、传播含有淫秽、色情、暴力、恐怖或煽动民族仇恨、民族歧视的信息；',
        title73: '(3) 侵犯他人知识产权或其他合法权益，如版权、专利、商标、商业秘密等；',
        title74: '(4) 编造或传播虚假信息，扰乱经济秩序和社会秩序；',
        title75: '(5) 从事传销、欺诈、赌博等违法活动；',
        title76: '(6) 其他违反法律法规、规则、政策、社会公德或本协议规定的行为。',
        title77: '6.2 您应对您的 ipipbright 账号下的所有行为承担全部责任。如果您使用 ipipbright 服务给 ipipbright 或第三方造成损失，您应承担相应的法律责任。',
        title78: '6.3 您应妥善保管您的 ipipbright 账号和密码，不得向他人泄露。如果您的账号或密码被窃取或被他人使用，您应立即通知 ipipbright，ipipbright 将根据实际情况采取适当措施。',
        title79: '第七条 知识产权',
        title80: '7.1 与 ipipbright 服务相关的所有知识产权（包括但不限于软件、文本、图像、音频、视频、标志、商标等）属于 ipipbright 或其许可方所有。您不得以任何方式侵犯这些知识产权。',
        title81: '7.2 您同意，ipipbright 有权使用、复制、修改、改编、发布、翻译、分发、执行和展示您的用户信息、反馈、建议等内容，或将其纳入其他作品，以任何形式、媒体或现在已知或以后开发的技术，无需向您支付任何报酬。',
        title82: '7.3 您应确保您通过 ipipbright 服务发布或传输的内容不侵犯他人的知识产权。如果您侵犯了他人的知识产权，您应承担相应的法律责任，ipipbright 有权删除侵权内容，并采取暂停或终止您账户等措施。',
        title83: '第八条 免责声明',
        title84: '8.1 ipipbright 将尽最大努力确保服务的正常运行，但 ipipbright 不保证服务无错误、不间断或服务完全安全。您使用 ipipbright 服务的风险由您自行承担。',
        title85: '8.2 ipipbright 不对因不可抗力（如自然灾害、战争、政府行为等）造成的任何直接或间接损失承担责任。',
        title86: '8.3 ipipbright 不对因您自身原因（如账户管理不当、操作不当等）造成的任何损失承担责任。',
        title87: '8.4 ipipbright 不对因第三方（如第三方网站故障、网络攻击等）造成的任何损失承担责任。',
        title88: '8.5 ipipbright 不对因您违反本协议或相关法律法规造成的任何损失承担责任。',
        title89: '第九条 争议解决',
        title90: '9.1 本协议的订立、履行、解释和争议解决均适用中华人民共和国法律。',
        title91: '9.2 因本协议引起或与本协议有关的任何争议，应由双方通过友好协商解决。协商不成的，任何一方均可向 ipipbright 所在地有管辖权的人民法院提起诉讼。',
        title92: '9.3 在争议解决过程中，双方应继续履行本协议中无争议的部分。',
        title93: '第十条 其他条款',
        title94: '10.1 如果本协议的任何条款被有管辖权的法院认定为无效或不可执行，本协议其他条款的有效性和可执行性不受影响。',
        title95: '10.2 ipipbright 未行使或执行本协议的任何权利或条款，不构成对该权利或条款的放弃。',
        title96: '10.3 ipipbright 有权将本协议项下的全部或部分权利和义务转让给第三方。在这种情况下，ipipbright 将以适当方式通知您。',
        title97: '10.4 本协议各条款的标题仅为方便阅读而设，不影响对本协议内容的解释。',
        title98: '10.5 本协议是您与 ipipbright 之间关于 ipipbright 服务的完整协议，取代双方之前关于 ipipbright 服务的所有口头或书面协议、谅解和通信。',
        title99: '10.6 如果您对本协议有任何疑问或建议，可联系 ipipbright 客服。',
        title100: '第十一条 协议变更',
        title101: '11.1 ipipbright 保留随时修改本协议的权利。一旦本协议内容发生变更，ipipbright 将在官方网站上发布变更后的协议。您可在官方网站上查看最新的协议内容。',
        title102: '11.2 如果您不同意变更后的协议，您应立即停止使用 ipipbright 服务。如果您在协议变更后继续使用 ipipbright 服务，即视为您接受变更后的协议。',
        title103: '第十二条 生效日期',
        title104: '12.1 本协议自您注册账号或通过 ipipbright 允许的其他方式实际使用 ipipbright 服务之日起生效。',
        title105: '12.2 本协议有效期至您终止使用 ipipbright 服务或 ipipbright 终止向您提供服务之日止。',
        title106: '第十三条 联系方式',
        title107: '13.1 如果您对本协议或 ipipbright 服务有任何疑问，可通过以下方式联系 ipipbright 客服：',
        title108: '邮箱：super@ipipbright.net',
        title109: '第十四条 可分割性',
        title110: '14.1 如果本协议的任何条款被有管辖权的法院认定为无效或不可执行，本协议的其余条款仍应保持完全效力。',
        title111: '14.2 本协议任何条款的无效或不可执行，不影响本协议其他条款的有效性或可执行性。',
        title112: '第十五条 完整协议',
        title113: '15.1 本协议构成您与 ipipbright 之间关于本协议标的的完整协议，取代双方之前关于本协议标的的所有书面和口头理解、协议、陈述和保证。',
        title114: '15.2 对本协议的任何修改，只有经双方书面签署或由 ipipbright 在官方网站上发布，才具有法律效力。',
        title115: '第十六条 适用法律',
        title116: '16.1 本协议受中华人民共和国法律管辖并按其解释。',
        title117: '16.2 因本协议引起或与本协议有关的任何争议，应提交 ipipbright 所在地有管辖权的人民法院解决。',
        title118: '第十七条 通知',
        title119: '17.1 本协议要求或允许的任何通知或通信，均应采用书面形式，并在当面交付、通过挂号邮件发送或通过电子邮件发送至另一方提供的地址时视为已适当送达。',
        title120: '17.2 如果您变更联系方式，应及时通知 ipipbright。因您未及时更新联系方式而造成的任何损失，ipipbright 不承担责任。',
        title121: '第十八条 弃权',
        title122: '18.1 ipipbright 未行使或执行本协议的任何权利或条款，不构成对该权利或条款的放弃。',
        title123: '18.2 ipipbright 对任何违约行为的弃权，不构成对任何后续违约行为的弃权。',
        title124: '18.3 对本协议任何条款的弃权，只有经 ipipbright 书面签署才具有法律效力。',
        title125: '第十九条 转让',
        title126: '19.1 未经 ipipbright 事先书面同意，您不得将本协议项下的任何权利或义务转让给任何第三方。',
        title127: '19.2 ipipbright 可在不征得您同意的情况下，将本协议项下的全部或部分权利和义务转让给第三方，但 ipipbright 将以适当方式通知您此类转让。'
      }
    };
  },
  computed: {
    t() {
      const currentLanguage = this.languageState.currentLanguage;
      return this.i18n[currentLanguage];
    }
  },
  methods: {
    // 切换移动端菜单
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },
    // 处理移动端导航点击
    handleMobileNavClick(path) {
      this.isMobileMenuOpen = false;
      // 检查当前路由是否已经是目标路由，避免冗余导航警告
      if (this.$route.path !== path) {
        this.$router.push(path);
      }
    },
    // 切换下拉菜单
    toggleDropdown(event, dropdownName) {
      event.preventDefault();
      if (this.activeDropdown === dropdownName) {
        this.activeDropdown = '';
      } else {
        this.activeDropdown = dropdownName;
      }
    },
    // 设置语言
    setLanguage(lang) {
      this.changeLanguage(lang);
      this.activeDropdown = '';
    },
    // 回到顶部
    scrollToTop() {
      window.location.href = '#';
      document.documentElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      document.body.scrollIntoView({ behavior: 'smooth', block: 'start' });
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    },
    // 检测滚动位置
    checkScrollPosition() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      const goTopButton = document.getElementById('simple-go-top');
      if (goTopButton) {
        if (scrollTop > 300) {
          goTopButton.style.opacity = '1';
          goTopButton.style.visibility = 'visible';
        } else {
          goTopButton.style.opacity = '0';
          goTopButton.style.visibility = 'hidden';
        }
      }
      this.scrollAnimationFrame = requestAnimationFrame(this.checkScrollPosition);
    }
  },
  mounted() {
    // 初始化滚动检测
    this.scrollAnimationFrame = requestAnimationFrame(this.checkScrollPosition);
  },
  beforeUnmount() {
    // 清除动画帧
    if (this.scrollAnimationFrame) {
      cancelAnimationFrame(this.scrollAnimationFrame);
    }
  }
};
</script>

<style scoped>
/* 添加必要的样式 */
.service-policy-page {
  font-family: Arial, sans-serif;
  line-height: 1.6;
  color: #333;
}

/* 确保banner section的文字在深色背景上可见 */
.faq-banner-section {
  background-color: #2d2c28;
  color: white;
  margin-top: 100px; /* 为固定顶部导航栏留出空间 */
}

/* Padding styles */
.ptb-100 {
  padding-top: 100px;
  padding-bottom: 100px;
}

/* Background styles */
.bg-light {
  background-color: #2d2c28 !important;
}

/* 确保banner内容居中显示 */
.banner-content {
  text-align: center;
  color: white;
}

/* 确保banner标题和副标题在深色背景上可见 */
.banner-content h1 {
  color: white;
  font-size: 2.5rem;
  margin-bottom: 1rem;
}

.banner-content p {
  color: white;
  font-size: 1.1rem;
  opacity: 0.9;
}

/* 服务政策内容样式 */
.policy-content-section {
  background-color: #2d2c28 !important;
  padding: 60px 0;
  color: white;
}

.policy-content {
  background-color: #2d2c28;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.policy-header {
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid #2d2c28;
}

.policy-header h2 {
  font-size: 1.8rem;
  color: white;
  margin-bottom: 10px;
}

.policy-meta {
  display: flex;
  gap: 20px;
  color: #ccc;
  font-size: 0.9rem;
}

.policy-body {
  font-size: 1rem;
  color: white;
}

.policy-section {
  margin-bottom: 30px;
  color: white;
}

.policy-section h3 {
  font-size: 1.4rem;
  color: white;
  margin-bottom: 15px;
  margin-top: 25px;
}

.policy-section h4 {
  font-size: 1.2rem;
  color: white;
  margin-bottom: 10px;
  margin-top: 20px;
}

.policy-section p {
  margin-bottom: 15px;
  color: white;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .policy-content {
    padding: 20px;
  }
  
  .banner-content h1 {
    font-size: 2rem;
  }
  
  .policy-meta {
    flex-direction: column;
    gap: 5px;
  }
}
/* Mobile menu container */
.mobile-menu-container {
  position: relative;
  z-index: 99999;
}

/* Mobile menu header sticky styles */
.mobile-menu-header {
  position: fixed !important;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 99999;
  background: #32312d;
  min-height: 60px;
  padding: 4px 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* Mobile menu body should be fixed to viewport */
.mobile-menu-body {
  position: fixed !important;
  top: 60px;
  left: 0;
  right: 0;
  /* Make menu height smaller than full viewport */
  max-height: 70vh;
  margin-top: 0;
  z-index: 99998;
  overflow-y: auto;
  background: rgba(0, 0, 0, 0.95) !important;
  backdrop-filter: blur(10px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  border: none !important;
}

/* Make menu list background transparent */
.mobile-menu-list {
  background: transparent !important;
}

/* Make menu items background transparent */
.mobile-menu-item {
  background: transparent !important;
  border-top: 1px solid rgba(255, 255, 255, 0.1) !important;
}

/* Adjust menu link styles */
.mobile-menu-link {
  color: #fff !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.mobile-menu-link:hover {
  color: #1581c6 !important;
  transform: translateX(10px);
  background: rgba(21, 129, 198, 0.1);
}

.mobile-menu-link::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 4px;
  height: 100%;
  background: #1581c6;
  transform: scaleY(0);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.mobile-menu-link:hover::before {
  transform: scaleY(1);
}

.mobile-menu-expand {
  color: #fff !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.mobile-menu-expand:hover {
  color: #1581c6 !important;
  transform: rotate(180deg) scale(1.2);
}

.mobile-sub-menu {
  background: rgba(255, 255, 255, 0.08) !important;
  max-height: 300px;
  padding: 15px 0;
  animation: fadeInUp 0.4s ease forwards;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.mobile-sub-menu-link {
  color: #fff !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.mobile-sub-menu-link:hover {
  color: #1581c6 !important;
  transform: translateX(15px);
  background: rgba(21, 129, 198, 0.15);
}

.mobile-sub-menu-link::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 3px;
  height: 100%;
  background: #1581c6;
  transform: scaleY(0);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.mobile-sub-menu-link:hover::before {
  transform: scaleY(1);
}

.mobile-auth-btn {
  color: #fff !important;
  background: rgba(21, 129, 198, 0.3) !important;
  border: 1px solid rgba(21, 129, 198, 0.5) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.mobile-auth-btn:hover {
  background: rgba(21, 129, 198, 0.5) !important;
  color: #fff !important;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(21, 129, 198, 0.4);
}

/* Mobile menu toggle button */
.mobile-menu-toggle {
  width: 40px;
  height: 40px;
  padding: 10px;
  cursor: pointer;
  color: #fff;
  text-decoration: none;
  font-size: 16px;
  line-height: 20px;
  font-weight: 700;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  margin-right: 15px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;
}

.mobile-menu-toggle:hover {
  background: rgba(255, 255, 255, 0.2);
}

.mobile-menu-toggle span {
  display: block;
  background: #fff;
  height: 3px;
  width: 24px;
  margin: 2px 0;
  transition: all 0.3s ease;
  border-radius: 2px;
}

/* Remove margin-top on mobile */
@media (max-width: 768px) {
  .faq-banner-section {
    margin-top: 0;
    background-color: #2d2c28 !important;
  }
}
</style>
